var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "11px",
    viewBox: "0 0 8 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,1.63690909 L8,2.72781818 C8,2.86745455 7.951,3.00654545 7.8535,3.11290909 L7.8535,3.11290909 L5,6.22581818 L5,9.27272727 C5,9.41781818 4.947,9.55636364 4.8535,9.65836364 L4.8535,9.65836364 L3.8535,10.7492727 C3.758,10.8534545 3.63,10.9090909 3.5,10.9090909 C3.4355,10.9090909 3.3705,10.896 3.3085,10.8676364 C3.122,10.7830909 3,10.584 3,10.3636364 L3,10.3636364 L3,6.22636364 L0.1465,3.11345455 C0.049,3.00709091 0,2.86745455 0,2.72781818 L0,2.72781818 L0,1.63690909 L8,1.63690909 Z M7,-3.18634008e-14 C7.552,-3.18634008e-14 8,0.48981818 8,1.09090909 L8,1.09090909 L0,1.09090909 C0,0.48981818 0.4485,-3.18634008e-14 1,-3.18634008e-14 L1,-3.18634008e-14 Z",
    id: "Combined-Shape"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.c6db4c417656e69983bbfc9ce87df5e7.svg";
export { ForwardRef as ReactComponent };